// Lakai — unified card size-panel behaviour (design handoff 2026-08-04 §5).
// One delegated listener set for every card on the page, server-rendered
// (collection/search/related rail) or client-rendered (homepage grid via
// p7-sale.js) — delegation survives re-renders. This file only opens and
// closes the panel; size-chip FILTER wiring lives in p7-card-filter.js.
// Loaded once by snippets/p7-card-css.liquid; the guard below keeps a
// second tag from double-binding.
(function () {
  'use strict';
  if (window.__p7CardInit) return;
  window.__p7CardInit = true;

  var open = function (card, on) {
    var panel = card.querySelector('[data-panel]');
    var btn = card.querySelector('[data-toggle]');
    if (!panel || !btn) return;
    panel.hidden = !on;
    btn.setAttribute('aria-expanded', String(on));
  };
  var closeAll = function (except) {
    var cards = document.querySelectorAll('[data-card]');
    Array.prototype.forEach.call(cards, function (c) {
      if (c !== except) open(c, false);
    });
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-toggle]');
    if (btn) {
      var card = btn.closest('[data-card]');
      var wasOpen = btn.getAttribute('aria-expanded') === 'true';
      closeAll(card);
      open(card, !wasOpen);
      return;
    }
    // Any click outside an open card closes it — chips are links, so
    // picking a size navigates (or is intercepted by p7-card-filter.js)
    // and the panel state resolves on the next render.
    if (!e.target.closest('[data-panel]')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  // Keyboard parity for links/chips without fighting the toggle button.
  // On touch browsers focus fires before click; opening on toggle focus made the
  // following click immediately close the drawer, so it took two taps to open.
  document.addEventListener('focusin', function (e) {
    if (e.target.closest('[data-toggle]')) return;
    var card = e.target.closest('[data-card]');
    if (card) {
      closeAll(card);
      open(card, true);
    } else {
      closeAll(null);
    }
  });

  // Desktop: hover opens, no click needed — UNLESS a shoe size filter is
  // active (html.p7-shoe-size-active, stamped by p7-size-prefs.js). Once a
  // shopper has picked their size, the drawer firing on every hover is
  // churn; the card CSS shows a "Change size" hint on the stock line
  // instead, and click/keyboard still open the panel (owner 2026-08-04).
  if (matchMedia('(hover: hover) and (min-width: 1000px)').matches) {
    document.addEventListener('pointerover', function (e) {
      var card = e.target.closest('[data-card]');
      if (card) {
        if (document.documentElement.classList.contains('p7-shoe-size-active')) return;
        closeAll(card);
        open(card, true);
      }
    });
    document.addEventListener('pointerout', function (e) {
      var card = e.target.closest('[data-card]');
      if (card && !card.contains(e.relatedTarget)) open(card, false);
    });
  }
})();
